export default "__VITE_ASSET__855d0b56__"